import script from "./payment_entry.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment_entry.vue?vue&type=script&setup=true&lang=ts"

import "./payment_entry.vue?vue&type=style&index=0&id=4690a66c&scoped=true&lang=css"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4690a66c"]])

export default __exports__